import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from './useMutation';

export type CacheOption = 'invalidate' | 'reset';

export const useResetQuery = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { cacheResetOption: CacheOption }>({
    async mutationFn({ cacheResetOption }) {
      switch (cacheResetOption) {
        case 'invalidate':
          return queryClient.invalidateQueries();
        case 'reset':
          return queryClient.resetQueries();
      }
    },
  });
};
